
export const FRONTEND_DOMAINS = {
    CP: "CP",
    STAFF: "STAFF",
    ABC: "ABC",
    VCP: "VCP"
};

export const DOMAINS = {
    CP: {
        url: ".cargo-partner.com",
        domain: FRONTEND_DOMAINS.CP
    },
    ABC: {
        url:".abc-airsea.com",
        domain: FRONTEND_DOMAINS.ABC
    },
    VCP: {
        url: ".spotworx.com",
        domain: FRONTEND_DOMAINS.VCP
    }
};